import { TicketIcon } from 'foundations-assets';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import ThreadCrmTicketCreatedHeader from './ThreadCrmTicketCreatedHeader';
import SystemMessage from '../system-message/SystemMessage';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadCrmTicketCreatedTile = ({
  message,
  portalId,
  senders,
  userId,
  ungatedForThreadMessagesUIImprovements
}) => /*#__PURE__*/_jsx(SystemMessage, {
  timestamp: getTimestamp(message),
  description: /*#__PURE__*/_jsx(ThreadCrmTicketCreatedHeader, {
    message: message,
    senders: senders,
    userId: userId,
    portalId: portalId
  }),
  icon: /*#__PURE__*/_jsx(IconCircle, {
    borderWidth: "0",
    icon: TicketIcon,
    size: "500"
  }),
  ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
});
ThreadCrmTicketCreatedTile.displayName = 'ThreadCrmTicketCreatedTile';
export default ThreadCrmTicketCreatedTile;